import { Box, Typography } from '@mui/material';
import { ERPJobFormValues } from '../../../../ERPJobValidationSchema';
import { FormikTextField } from '@/common/presentation/components/forms/fields/FormikTextField';
import tid from '@/common/application/utils/tid';

interface ERPEstimatesSectionProps {
  volumeRequired?: boolean;
}

export function ERPEstimatesSection({ volumeRequired = false }: ERPEstimatesSectionProps) {
  return (
    <>
      <Typography variant="h6" component="div" sx={{ fontSize: '1rem', mb: '12px', fontWeight: 600 }}>
        Estimates
      </Typography>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-around', gap: { xs: '0px', sm: '12px' }, flexDirection: { xs: 'column', sm: 'row' } }}
      >
        <FormikTextField<ERPJobFormValues>
          id="estimatedVolume"
          label="Estimated Volume (cu yds)"
          type="number"
          inputProps={{ step: 0.01, min: 0 }}
          sx={{ flex: 1 }}
          required={volumeRequired}
          {...tid('jobs:create:estimated-volume-input')}
        />
        <FormikTextField<ERPJobFormValues>
          id="estimatedArea"
          label="Estimated Area (sq ft)"
          type="number"
          inputProps={{ step: 0.01, min: 0 }}
          sx={{ flex: 1 }}
          {...tid('jobs:create:estimated-area-input')}
        />
      </Box>
    </>
  );
}
